export default "__VITE_ASSET__Blx2nlX7__"